import { useCallback } from "react";

function useSessionStorage<T>() {
  const setItem = useCallback((key: string, value: T) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("Error setting session storage:", error);
    }
  }, []);

  const getItem = useCallback((key: string): T | null => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      console.error("Error getting session storage:", error);
      return null;
    }
  }, []);

  const removeItem = useCallback((key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing session storage:", error);
    }
  }, []);

  return { setItem, getItem, removeItem };
}

export default useSessionStorage;
